import { useAuth, SignIn as ClerkSignIn } from '@clerk/clerk-react';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card } from '../components/ui';
import { useAppConfig } from '../hooks/useAppConfig';

export function SignIn() {
  const { isLoaded, isSignedIn } = useAuth();
  const navigate = useNavigate();
  const { config } = useAppConfig();

  useEffect(() => {
    if (isLoaded && isSignedIn) {
      navigate('/dashboard');
    }
  }, [isLoaded, isSignedIn, navigate]);

  const appTitle = config?.title || 'Learn by Campaign';

  const clerkAppearance = {
    variables: {
      colorBackground: '#05070d',
      colorPrimary: '#2de2e6',
      colorText: '#e8ecf7',
      colorInputBackground: '#1a2236',
      colorInputText: '#e8ecf7',
      colorDanger: '#ff3cac',
      fontFamily: "'Space Grotesk', sans-serif",
      borderRadius: '0.5rem',
    },
    elements: {
      card: {
        backgroundColor: '#0b0f1a',
        boxShadow: '0 0 12px rgba(45, 226, 230, 0.3)',
        border: '1px solid #2a3550',
      },
      formButtonPrimary: {
        backgroundColor: '#2de2e6',
        color: '#000000',
        boxShadow: '0 0 12px rgba(45, 226, 230, 0.6)',
      },
    },
  };

  if (!isLoaded) {
    return (
      <div
        style={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: 'var(--color-bg)',
          padding: 'var(--space-4)',
        }}
      >
        <Card>
          <p style={{ color: 'var(--color-text-secondary)' }}>Loading...</p>
        </Card>
      </div>
    );
  }

  if (isSignedIn) {
    return null;
  }

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        fontFamily: 'var(--font-sans)',
        backgroundColor: 'var(--color-bg)',
        padding: 'var(--space-4)',
      }}
    >
      <div style={{ marginBottom: '2rem', textAlign: 'center' }}>
        <h1
          style={{
            fontSize: '1.875rem',
            fontWeight: 'bold',
            color: 'var(--color-text)',
            margin: 0,
            marginBottom: '0.5rem',
          }}
        >
          {appTitle}
        </h1>
        <p
          style={{
            color: 'var(--color-text-secondary)',
            margin: 0,
          }}
        >
          Sign in to continue
        </p>
      </div>
      <ClerkSignIn
        redirectUrl="/dashboard"
        appearance={clerkAppearance}
      />
    </div>
  );
}
